export const isMatchingArray = (
  array1: string[] | number[],
  array2: string[] | number[],
  mustMatchOrder?: boolean,
) => {
  if (mustMatchOrder) {
    return JSON.stringify(array1) === JSON.stringify(array2);
  }
  const array1Sorted = [...array1].sort();
  const array2Sorted = [...array2].sort();
  return JSON.stringify(array1Sorted) === JSON.stringify(array2Sorted);
};
